import * as React from 'react';
import {
  Platform,
  StatusBar,
  StatusBarProps,
  useColorScheme,
} from 'react-native';
import {useIsFocused} from '@react-navigation/native';

interface Props extends StatusBarProps {
  forceDark?: boolean;
}

export function FocusAwareStatusBar({forceDark = false, ...props}: Props) {
  const isFocused = useIsFocused();

  const scheme = useColorScheme();

  const computedBarStyle =
    props.barStyle ??
    (scheme === 'dark'
      ? forceDark
        ? 'dark-content'
        : 'light-content'
      : 'dark-content');

  const translucent = props.translucent ?? false;

  return isFocused ? (
    <StatusBar
      {...props}
      translucent={translucent}
      backgroundColor={props.backgroundColor}
      barStyle={computedBarStyle}
    />
  ) : null;
}
